// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { DevicesList } from "@/features/hardware/devices-list";

interface StoreDevicesTabProps {
  storeName: string;
  // Accepted for parity with the other tabs; the embedded devices list manages its own state.
  initialFilters?: string;
}

// The store's devices are the full Devices list scoped to this store — same columns (minus Store and
// Chain, which are implied here) with search and the active toggle.
export function StoreDevicesTab({ storeName }: StoreDevicesTabProps) {
  return <DevicesList storeName={storeName} />;
}
